import { Navigate, Outlet } from 'react-router-dom'
import { useAuthContext, UserInfo } from '../../AuthContext'
import { ADMIN_HOME } from '../AdminLayout/PublicLayout'

// Only the boolean permission flags — userId/name shouldn't be passable as a "requires".
type Permission = {
  [K in keyof UserInfo]-?: UserInfo[K] extends boolean | undefined ? K : never
}[keyof UserInfo]

type Props = {
  requires: Permission
}

const LoadingShell = () => (
  <div className='px-8 md:px-24 py-8 animate-pulse'>
    <div className='h-8 w-1/3 bg-gray-200 rounded mb-4' />
    <div className='h-4 w-full bg-gray-200 rounded mb-2' />
    <div className='h-4 w-2/3 bg-gray-200 rounded' />
  </div>
)

export const EntitledRoute = ({ requires }: Props) => {
  const { user, userInfo, isSignInLoading, isUserInfoLoading } = useAuthContext()

  // Wait until both auth and userInfo finish loading — avoids redirecting
  // legitimate users while their entitlements are still being fetched.
  if (isSignInLoading || isUserInfoLoading) return <LoadingShell />

  // ProtectedRoute already enforces this, but defend in depth.
  if (!user) return <Navigate to='/login' replace />

  // No row in users table OR permission flag is false → not entitled.
  if (!userInfo?.[requires]) return <Navigate to={ADMIN_HOME} replace />

  return <Outlet />
}
